import { render } from "./DataView.vue?vue&type=template&id=3c44dbe3"
import script from "./DataView.vue?vue&type=script&lang=js"
export * from "./DataView.vue?vue&type=script&lang=js"
script.render = render

export default script